import { LangChangeEvent } from "@ngx-translate/core";
import { GATitle, Path } from "../_common/constant/page-const";

declare let gtag: any;

export class GAManager {

       private map:Map<string,string> = new Map();
       public  isReady:boolean = false;

       public send(url:string) {
              let title = this.map.get(url);
              gtag('event', 'page_view', {
                  page_title: title,
                  page_path: url    // @@need to VERIFY :: no need to send_to: '<GA_MEASUREMENT_ID>'
              })
       }

       public setTitle(event: LangChangeEvent) {

              let trans = event.translations;

              this.map.set('/'+Path.Start,trans[Path.Start].page_title);
              this.map.set('/'+Path.BeforeYouBegin,trans[Path.BeforeYouBegin].page_title);
              this.map.set('/'+Path.Setup1,trans[Path.Setup1].page_title);
              this.map.set('/'+Path.Setup2,trans[Path.Setup2].page_title);
              this.map.set('/'+Path.Setup3,trans[Path.Setup3].page_title);
              this.map.set('/'+Path.Setup4,trans[Path.Setup4].page_title);
              this.map.set('/'+Path.Setup5,trans[Path.Setup5].page_title);
              this.map.set('/'+Path.AboutTheChildMain,trans[Path.AboutTheChildMain].page_title);
              this.map.set('/'+Path.AboutTheChildScreen2,trans[Path.AboutTheChildScreen2].page_title);
              this.map.set('/'+Path.AboutTheParentsMain,trans['aboutParent'].page_title);
              this.map.set('/'+Path.AboutTheParentsScreen1,trans['parentScreen'].page_title);
              this.map.set('/'+Path.AboutTheParentsScreen2,trans['parentScreen'].page_title);
              this.map.set('/'+Path.AboutTheParentsScreen3,trans['parentScreen'].page_title);
              this.map.set('/'+Path.AboutTheParentsScreen4,trans['parentScreen'].page_title);
              this.map.set('/'+Path.ContactInfoAndMailingAddress,trans[Path.ContactInfoAndMailingAddress].page_title);
              this.map.set('/'+Path.FinalReview,trans[Path.FinalReview].page_title);
              this.map.set('/'+Path.Transition1,trans[Path.Transition1].page_title);
              this.map.set('/'+Path.BirthCertificate,trans[Path.BirthCertificate].page_title);
              this.map.set('/'+Path.BirthCertificateAreYouSure,trans[Path.BirthCertificateAreYouSure].page_title);

              this.map.set('/'+Path.Transition2,trans[Path.Transition2].page_title);
              this.map.set('/'+Path.CCBMain,trans[Path.CCBMain].page_title);
              this.map.set('/'+Path.CCBAreYouSure,trans[Path.CCBAreYouSure].page_title);
              this.map.set('/'+Path.SINMain,trans[Path.SINMain].page_title);
              this.map.set('/'+Path.SINAreYouSure,trans[Path.SINAreYouSure].page_title);
              this.map.set('/'+Path.ESRMain,trans[Path.ESRMain].page_title);

              this.map.set('/'+Path.ESRAreYouSure,trans[Path.ESRAreYouSure].page_title);
              this.map.set('/'+Path.OrderSummary,trans[Path.OrderSummary].page_title);
              this.map.set('/'+Path.NextRegistration,trans[Path.NextRegistration].page_title);
              this.map.set('/'+Path.ProvincialPayment,trans[Path.ProvincialPayment].page_title);
              this.map.set('/'+Path.FAQ,trans[Path.FAQ].page_title);
              this.map.set('/'+Path.ORGContactInformation,trans[Path.ORGContactInformation].page_title);

              //this.map.set('/'+Path.Start,trans[Path.Start].page_title);
              //this.map.set('/'+Path.Start,trans[Path.Start].page_title);
              //this.map.set('/'+Path.Start,trans[Path.Start].page_title);

              this.isReady = true;
              
       }

       constructor() {
             /**
                this.map.set('/'+Path.Start,GATitle.Start);
                this.map.set('/'+Path.BeforeYouBegin,GATitle.BeforeYouBegin);
                this.map.set('/'+Path.Setup1,GATitle.Setup1);
                this.map.set('/'+Path.Setup2,GATitle.Setup2);
                this.map.set('/'+Path.Setup3,GATitle.Setup3);
                this.map.set('/'+Path.Setup4,GATitle.Setup4);
                this.map.set('/'+Path.Setup5,GATitle.Setup5);
                this.map.set('/'+Path.AboutTheChildMain,GATitle.AboutTheChildMain);
                this.map.set('/'+Path.AboutTheChildScreen2,GATitle.AboutTheChildScreen2);
                this.map.set('/'+Path.AboutTheParentsMain,GATitle.AboutTheParentsMain);
                this.map.set('/'+Path.AboutTheParentsScreen1,GATitle.AboutTheParentsScreen1);
                this.map.set('/'+Path.AboutTheParentsScreen2,GATitle.AboutTheParentsScreen2);
                this.map.set('/'+Path.AboutTheParentsScreen3,GATitle.AboutTheParentsScreen3);
                this.map.set('/'+Path.AboutTheParentsScreen4,GATitle.AboutTheParentsScreen4);
                this.map.set('/'+Path.ContactInfoAndMailingAddress,GATitle.ContactInfoAndMailingAddress);
                this.map.set('/'+Path.FinalReview,GATitle.FinalReview);
                this.map.set('/'+Path.Transition1,GATitle.Transition1);
                this.map.set('/'+Path.BirthCertificate,GATitle.BirthCertificate);
                this.map.set('/'+Path.BirthCertificateAreYouSure,GATitle.BirthCertificateAreYouSure);

                this.map.set('/'+Path.Transition2,GATitle.Transition2);
                this.map.set('/'+Path.CCBMain,GATitle.CCBMain);
                this.map.set('/'+Path.CCBAreYouSure,GATitle.CCBAreYouSure);
                this.map.set('/'+Path.SINMain,GATitle.SINMain);
                this.map.set('/'+Path.SINAreYouSure,GATitle.SINAreYouSure);
                this.map.set('/'+Path.ESRMain,GATitle.ESRMain);

                this.map.set('/'+Path.ESRAreYouSure,GATitle.ESRAreYouSure);
                this.map.set('/'+Path.OrderSummary,GATitle.OrderSummary);
                this.map.set('/'+Path.NextRegistration,GATitle.NextRegistration);
                this.map.set('/'+Path.ProvincialPayment,GATitle.ProvincialPayment);
                this.map.set('/'+Path.AdditionalInfo,GATitle.AdditionalInfo);
                this.map.set('/'+Path.FAQ,GATitle.FAQ);
                this.map.set('/'+Path.ORGContactInformation,GATitle.ORGContactInformation);
                this.map.set('/'+Path.Start,GATitle.Start);
                this.map.set('/'+Path.Start,GATitle.Start);
                this.map.set('/'+Path.Start,GATitle.Start);
                 */
       }
}

